import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ShopActions, selectAllowOrder, selectIsDone, selectIsPending } from '@us/web/shop/data-access';
import { filter, switchMap, tap } from 'rxjs';

export const checkAllowOrderGuard: CanActivateFn = () => {
    const router = inject(Router);
    const store = inject(Store);

    return store.select(selectIsPending).pipe(
        tap(isPending => {
            if (isPending) {
                store.dispatch(ShopActions.loadShop({}));
            }
        }),
        switchMap(() => store.select(selectIsDone)),
        filter(isDone => isDone),
        switchMap(() => store.select(selectAllowOrder)),
        tap(allowOrder => {
            if (!allowOrder) {
                router.navigate(['/account/treatment-card']);
            }
        })
    );
};
